import { Col, Row, Typography } from "antd";
import React, { useState } from "react";
import AllHistoryPage from "./history/all_history_page";
import ProfitHistoryPage from "./history/profit_history_page";
import LossHistoryPage from "./history/loss_history_page";
import { CanlendarIcon } from "../../lib/svg_help";

const { Text } = Typography;
export default function HistoryPage({colors}) {
  const [activeTab, setActiveTab] = useState("all");
  const tabs = [
    { key: "all", label: "All" },
    { key: "profit", label: "Profit", disabled: true },
    { key: "loss", label: "Loss", disabled: true },
  ];

  const components = {
    all: AllHistoryPage,
    profit: ProfitHistoryPage,
    loss: LossHistoryPage,
  };

  const ActiveComponent = components[activeTab];
  return (
    <div>
      <Row justify="center" style={{ gap: "60px" }}>
        {tabs.map((tab) => (
          <Col key={tab.key} style={{ position: "relative" }}>
            <Text
              style={{
                cursor: "pointer",
              }}
              onClick={() => !tab.disabled && setActiveTab(tab.key)}
            >
              {tab.label}
            </Text>
            <span
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                bottom: -6,
                height: "3px",
                background: `linear-gradient(to right, ${colors.primary}, transparent)`,
                transition: "all 0.3s",
                width: activeTab === tab.key ? "80px" : "0",
              }}
            ></span>
          </Col>
        ))}
        <Col>
          <CanlendarIcon colors={colors}/>
        </Col>
        <Col span={24} style={{marginTop:"-30px"}}>
          <ActiveComponent colors = {colors} />
        </Col>
      </Row>
    </div>
  );
}
